import crudHandlers from "./_crud";

export default (state, action) => {
	const { type, payload } = action
	switch (type) {
		default:
			return crudHandlers(state, action, 'daily_plant_monitoring')
	}
}
